import { internalApiserverApi } from './internal-apiserver'

export type InternalFeatureMapEntry = {
  id: string
  legacyId: number
  name: string
  active: boolean
  choices?: { weightId: number; choice: string }[]
}

export type InternalFeatureMap = Record<string, InternalFeatureMapEntry>

const featuresApi = internalApiserverApi.injectEndpoints({
  endpoints: (builder) => ({
    getInternalFeatureMap: builder.query<InternalFeatureMap, { marketIso: string }>({
      query: ({ marketIso }) => ({ url: 'features/map/', params: { marketIso } }),
      providesTags: ['internalFeatures'],
    }),
  }),
})

export const { useGetInternalFeatureMapQuery } = featuresApi
